import React from 'react'

const styles = {width: '99vw', height: '88vh'};

function Caracterizacion() {
    return (
        <iframe title='Caracterizacion' 
        src="https://geologiaconce.maps.arcgis.com/apps/dashboards/9d1045925e014f41a428823a6b3c6ff8" 
        style={styles}></iframe>
    )
}

export default Caracterizacion
